import { useAuth } from "context/auth-context";
import { removeLoginCookie } from "../../components/LoginForm/LoginFormDao";
import { useNavigate } from "react-router-dom";
import { FiLogOut } from "react-icons/fi";
import { ModalFrame } from "components/ui";

const LogoutConfirmation = ({ onClose }:any) => {
  const { setAuth } = useAuth();
  const navigate = useNavigate();

  const handleLogout = () => {
    removeLoginCookie("setLoginCookie");
    localStorage.removeItem("bonusPopup");
    localStorage.removeItem("access_token");
    setAuth(null);
    navigate("/");
  };

  return (
    <ModalFrame labelledBy="logout-confirm-title" className="max-w-[400px]">
      <div className="p-6">
        <div className="flex items-start gap-4">
          <span className="zs-stat-icon w-10 h-10 bg-warning-soft text-warning">
            <FiLogOut aria-hidden="true" />
          </span>
          <div className="min-w-0">
            <h2 id="logout-confirm-title" className="text-lg font-bold leading-snug font-display text-ink">
              {"Are you sure you want to logout?"}
            </h2>
            <p className="mt-1 text-sm text-ink-3">
              {"You will be logged out from your account."}
            </p>
          </div>
        </div>

        <div className="flex flex-col-reverse gap-2 mt-6 sm:flex-row sm:justify-end">
          <button onClick={onClose} className="zs-btn zs-btn-secondary">
            Cancel
          </button>
          <button onClick={handleLogout} className="zs-btn zs-btn-primary">
            OK
          </button>
        </div>
      </div>
    </ModalFrame>
  );
};

export default LogoutConfirmation;
